import set_big_company from "./Images/Shashlik_sets/set_big_company Large.jpeg"
import set_chicken from "./Images/Shashlik_sets/set_chicken Large.jpeg"
import set_lamb from "./Images/Shashlik_sets/set_lamb Large.jpeg"
import set_trial from "./Images/Shashlik_sets/set_trial Large.jpeg"

import vegetables_champignons from "./Images/Vegetables/champignons Large.jpeg"
import vegetables_corn from "./Images/Vegetables/corn Large.jpeg"
import vegetables_eggplant from "./Images/Vegetables/eggplant Large.jpeg"
import vegetables_pepper_bulgarian from "./Images/Vegetables/pepper_bulgarian Large.jpeg"
import vegetables_pepper_hot from "./Images/Vegetables/pepper_hot Large.jpeg"
import vegetables_potatoes from "./Images/Vegetables/potatoes Large.jpeg"
import vegetables_assorted from "./Images/Vegetables/vegetables_assorted Large.jpeg"

import shashlik_chicken_full from "./Images/Shashliks/chicken_full Large.jpeg"
import shashlik_kebab from "./Images/Shashliks/kebab Large.jpeg"
import shashlik_kebab_chicken from "./Images/Shashliks/kebab_chicken Large.jpeg"
import shashlik_beef from "./Images/Shashliks/shashlik_beef Large.jpeg"
import shashlik_chicken_hip from "./Images/Shashliks/shashlik_chicken_hip Large.jpeg"
import shashlik_chicken_wings from "./Images/Shashliks/shashlik_chicken_wings Large.jpeg"
import shashlik_lamb from "./Images/Shashliks/shashlik_lamb Large.jpeg"
import shashlik_lamb_rack from "./Images/Shashliks/shashlik_lamb_rack Large.jpeg"
import shashlik_mutton_ribs from "./Images/Shashliks/shashlik_mutton_ribs Large.jpeg"
import shashlik_pork_neck from "./Images/Shashliks/shashlik_pork_neck Large.jpeg"
import shashlik_pork_rack from "./Images/Shashliks/shashlik_pork_rack Large.jpeg"
import shashlik_pork_ribs from "./Images/Shashliks/shashlik_pork_ribs Large.jpeg"

import salad_caesar from "./Images/Salads/salad_caesar Large.jpeg"
import salad_homemade from "./Images/Salads/salad_homemade Large.jpeg"
import salad_with_eggplants from "./Images/Salads/salad_with_eggplants Large.jpeg"

import pizza_chicken from "./Images/Pizzas/pizza_chicken Large.jpeg"
import pizza_pepperoni from "./Images/Pizzas/pizza_pepperoni Large.jpeg"

import drinks_coca_cola from "./Images/Drinks/coca_cola Large.jpeg"
import drinks_fanta from "./Images/Drinks/fanta Large.jpeg"
import drinks_sprite from "./Images/Drinks/sprite Large.jpeg"
import drinks_rich_cherry from "./Images/Drinks/rich_cherry Large.jpeg"
import drinks_rich_orange from "./Images/Drinks/rich_orange Large.jpeg"
import drinks_jermuk from "./Images/Drinks/jermuk Large.jpeg"

import sauces from "./Images/Sauces/sauces Large.jpeg"


export const ImageImporter : {[key:string] : any} = {
    "set_big_company" : set_big_company,
    "set_chicken" : set_chicken,
    "set_lamb" : set_lamb,
    "set_trial" : set_trial,

    "vegetables_champignons" : vegetables_champignons,
    "vegetables_corn" : vegetables_corn,
    "vegetables_eggplant" : vegetables_eggplant,
    "vegetables_pepper_bulgarian" : vegetables_pepper_bulgarian,
    "vegetables_pepper_hot" : vegetables_pepper_hot,
    "vegetables_potatoes" : vegetables_potatoes,
    "vegetables_assorted" : vegetables_assorted,

    "shashlik_chicken_full" : shashlik_chicken_full,
    "shashlik_kebab" : shashlik_kebab,
    "shashlik_kebab_chicken" : shashlik_kebab_chicken,
    "shashlik_beef" : shashlik_beef,
    "shashlik_chicken_hip" : shashlik_chicken_hip,
    "shashlik_chicken_wings" : shashlik_chicken_wings,
    "shashlik_lamb" : shashlik_lamb,
    "shashlik_lamb_rack" : shashlik_lamb_rack,
    "shashlik_mutton_ribs" : shashlik_mutton_ribs,
    "shashlik_pork_neck" : shashlik_pork_neck,
    "shashlik_pork_rack" : shashlik_pork_rack,
    "shashlik_pork_ribs" : shashlik_pork_ribs,

    "salad_caesar" : salad_caesar,
    "salad_homemade" : salad_homemade,
    "salad_with_eggplants" : salad_with_eggplants,

    "pizza_chicken" : pizza_chicken,
    "pizza_pepperoni" : pizza_pepperoni,

    "drinks_coca_cola" : drinks_coca_cola,
    "drinks_fanta" : drinks_fanta,
    "drinks_sprite" : drinks_sprite,
    "drinks_rich_cherry" : drinks_rich_cherry,
    "drinks_rich_orange" : drinks_rich_orange,
    "drinks_jermuk" : drinks_jermuk,

    "sauces" : sauces
}